// Hook pro přístup k navigačnímu kontextu

import { useContext } from 'react';
import { useStore } from 'zustand';
import { NavigationContext, type NavigationContextValue } from './NavigationProvider';
import type { NavigationStoreState } from '../core/navigationStore';

/**
 * Vrátí navigační kontext (kernel + store).
 * Použitelné pro přímý přístup k navigačnímu kernelu.
 */
export function useNavigationContext(): NavigationContextValue {
  const ctx = useContext(NavigationContext);
  if (!ctx) {
    throw new Error('useNavigationContext must be used within NavigationProvider');
  }
  return ctx;
}

/**
 * Hook pro čtení ze Zustand store navigačního stavu.
 * Automaticky re-renderuje jen při změně vybraného selektoru.
 */
export function useNavigationStore<T>(selector: (state: NavigationStoreState) => T): T {
  const { store } = useNavigationContext();
  return useStore(store, selector);
}
